import KeepNType from 'owa-service/lib/contract/KeepNType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import BulkTriageActionType from 'owa-service/lib/contract/BulkTriageActionType';
import getFolderFromId from '../utils/folderTypeConversionUtil';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { BulkActionCustomDataBase, lazyOnBulkActionSubmitted } from 'owa-bulk-action-store';
import applyBulkItemActionService from '../services/applyBulkItemActionService';
import runRuleNow from '../actions/actionCreators/runRuleNow';
import { orchestrator } from 'satcheljs';
import InboxRule from 'owa-service/lib/contract/InboxRule';

export interface RuleBulkActionCustomData extends BulkActionCustomDataBase {
    ruleId?: string;
    ruleName: string;
}

export default orchestrator(runRuleNow, actionMessage => {
    let mailboxesToSweep: EmailAddressWrapper[] = [];
    let destinationFolderId: string;
    let senderSMTPs: string[] = [];
    let bulkActionCustomData: RuleBulkActionCustomData;
    const inboxRule: InboxRule = actionMessage.inboxRule;
    const sourceFolderId = actionMessage.sourceFolderId;

    if (inboxRule.From) {
        for (let identity of inboxRule.From) {
            let mailbox: EmailAddressWrapper = {
                Name: identity.DisplayName,
                EmailAddress: identity.SmtpAddress,
                RoutingType: identity.RoutingType,
            };
            mailboxesToSweep.push(mailbox);
            senderSMTPs.push(identity.SmtpAddress);
        }
    } else {
        throw new Error('Cannot run rule without sender(s)');
    }

    if (inboxRule.MoveToFolder) {
        let destinationFolder = getFolderFromId(inboxRule.MoveToFolder.RawIdentity);

        if (!destinationFolder) {
            throw new Error('Destination folder does not exist in store');
        } else {
            destinationFolderId = destinationFolder.folderId;
        }
    } else if (inboxRule.DeleteMessage) {
        destinationFolderId = folderNameToId('deleteditems');
    } else {
        throw new Error('Cannot run rule without destination folder');
    }

    bulkActionCustomData = {
        Scenario: 'RunRuleNow',
        ruleName: inboxRule.Name,
        ruleId: actionMessage.actionSource !== 'RuleDialog' ? inboxRule.Identity.RawIdentity : null,
    };
    lazyOnBulkActionSubmitted.importAndExecute(
        sourceFolderId ? sourceFolderId : folderNameToId('inbox'),
        'Sweep',
        bulkActionCustomData
    );

    applyBulkItemActionService(
        BulkTriageActionType.Move,
        mailboxesToSweep,
        sourceFolderId ? sourceFolderId : folderNameToId('inbox'),
        KeepNType.Items,
        0,
        destinationFolderId,
        bulkActionCustomData
    );
});
